import { ID, Task, UpdateTask } from '@griply/types';

import { countedGoalIds } from './links/counted-goal-ids';

export type TaskGoalRestoreAdjustment = {
  taskCount: number;
  completedTaskCount: number;
};

export type BuildTaskRestoreUpdatesOptions = {
  tasks: Task[];
  updateGoals: boolean;
};

export type TaskRestoreUpdates = {
  taskUpdates: UpdateTask[];
  goalAdjustments: Record<ID, TaskGoalRestoreAdjustment>;
  restoredTasks: Task[];
};

export const buildTaskRestoreUpdates = ({
  tasks,
  updateGoals,
}: BuildTaskRestoreUpdatesOptions): TaskRestoreUpdates => {
  const restoredTasks = tasks.filter(({ deletedAt }) => !!deletedAt);

  const goalAdjustments: Record<ID, TaskGoalRestoreAdjustment> = {};
  if (updateGoals) {
    restoredTasks.forEach((task) => {
      countedGoalIds(task).forEach((goalId) => {
        const current = goalAdjustments[goalId] ?? {
          taskCount: 0,
          completedTaskCount: 0,
        };
        current.taskCount += 1;
        if (task.completedAt) {
          current.completedTaskCount += 1;
        }
        goalAdjustments[goalId] = current;
      });
    });
  }

  const taskUpdates: UpdateTask[] = restoredTasks.map(({ id }) => ({
    id,
    deletedAt: null,
    archivedAt: null,
  }));

  return { taskUpdates, goalAdjustments, restoredTasks };
};
